import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MyProfileRoutingModule } from './my-profile-routing.module';
import { MyProfileComponent } from './my-profile.component';
import { MyProfileLandingPageComponent } from './my-profile-landing-page/my-profile-landing-page.component';
import { SharedModule } from '../shared/shared.module';



@NgModule({
  declarations: [MyProfileComponent,
    MyProfileLandingPageComponent],
  imports: [
    CommonModule,
    MyProfileRoutingModule,
    SharedModule
  ]
})
export class MyProfileModule { }
